export default __webpack_public_path__ + "static/media/full4.d3941639.jpg";